import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Clock } from "lucide-react";

/**
 * Shared Command Center module placeholder — used for Members, Vendor
 * Marketplace, Revenue, Support, Settings, Audit Logs modules per Build
 * Guide Phase 4. Each module gets its own route so nav links work today;
 * detail views land in a follow-up phase.
 */
export default function CommandCenterPlaceholder({ title, blurb, testId }) {
  return (
    <div className="min-h-screen bg-cream" data-testid={testId}>
      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-10">
        <Link
          to="/super-admin"
          className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#7A7A7A] hover:text-[#1A422D]"
        >
          <ChevronLeft size={14} /> Command Center
        </Link>

        <div className="mt-8">
          <div className="text-[12px] uppercase tracking-[0.28em] font-semibold text-[#B59A5A]">
            Command Center
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A422D] mt-2">
            {title}
          </h1>
        </div>

        <div className="mt-10 p-10 bg-white border border-[#E5E3D8] max-w-3xl">
          <div className="w-12 h-12 flex items-center justify-center bg-[#D9C68A]/25 text-[#8A6A2A]">
            <Clock size={22} />
          </div>
          <h2 className="mt-6 font-serif text-2xl text-[#1A422D]">
            {title} — Coming Soon.
          </h2>
          <p className="mt-4 text-[#4A4A4A] leading-relaxed">
            {blurb}
          </p>
          <p className="mt-4 text-sm text-[#7A7A7A]">
            All existing data is preserved. This module will surface here once the
            underlying feature ships — no schema changes on your end.
          </p>
        </div>
      </div>
    </div>
  );
}
